import { observer } from 'mobx-react';
import React from 'react';
import { Text } from 'telia-front-react';
import TradeInForm from './TradeInForm';
import TradeInPrice from './TradeInPrice';
const TradeInCalculator = (props) => {
    const { tradeInStore: { selectedDeviceId, answeredQuestions, initialConditions }, tradeInStore, headingElement, isLoggedIn, translate } = props;
    return (selectedDeviceId && (React.createElement(Text, { className: "text-center" },
        React.createElement(TradeInPrice, { headingElement: headingElement, tradeInStore: tradeInStore, translate: translate }),
        initialConditions.length === answeredQuestions.size && (React.createElement(TradeInForm, { tradeInStore: props.tradeInStore, translate: props.translate, isLoggedIn: isLoggedIn })))));
};
export default observer(TradeInCalculator);
